module.exports = __webpack_public_path__ + "static/media/people-simple-regular.8b0f4865.svg";